export class CreateServicioRequest {
    
    public id_TipoServicio :  number=0;
    public broche: boolean= false;
    public nroBroche: string = ""
    
}
